var map = {
	"./1/11/marquee.jpg": "UShP",
	"./1/16/marquee.jpg": "v2cq",
	"./1/17/marquee.jpg": "S+wD",
	"./2/1/marquee.jpg": "Wo/5",
	"./2/7/marquee.jpg": "XVHt",
	"./3/1/marquee.jpg": "v1os"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VhT1";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/marquee\.jpg$
// module id = VhT1
// module chunks = 39